import { render, staticRenderFns } from "./AllegatiComme.vue?vue&type=template&id=3f0887ed"
import script from "./AllegatiComme.vue?vue&type=script&lang=js"
export * from "./AllegatiComme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports